import { useEffect, useState } from "react";
import "./PageHero.css";

function PageHero({ title, media }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!media || media.length === 0) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % media.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [media]);

  return (
    <div className="page-hero">
      {media.map((item, i) => {
        const isActive = i === index;

        if (item.type === "video") {
          return (
            <video
              key={i}
              className={`hero-media ${isActive ? "active" : ""} ${i === 0 ? "first" : ""}`}
              src={item.src}
              autoPlay
              muted
              loop
              playsInline
            />
          );
        }

        return (
          <img
            key={i}
            className={`hero-media ${isActive ? "active" : ""} ${i === 0 ? "first" : ""}`}
            src={item.src}
            alt={item.alt || `${title} hero image ${i + 1}`}
          />
        );
      })}

      <div className="overlay"></div>
      <h1>{title}</h1>
    </div>
  );
}

export default PageHero;
